<template>
  <div id="app">

    <!-- 页首 -->
    <div class="header">
      <Head></Head>
    </div>

    <!-- 主体部分 -->
    <div class="main">
      <RouterView />
    </div>

    <!-- 页尾 -->
    <div class="foot">
      <Foot></Foot>
    </div>
  </div>
</template>

<script>
import Head from "./components/Head.vue"
import Foot from "./components/Foot.vue"
import { Loading } from 'element-ui';
import router from './router'; // 导入Vue Router实例
export default {
  name: 'App',
  components: {
    Head,
    Foot,
  },
  methods:{
    start(){
      let loadingInstance = Loading.service({
      fullscreen: true, // 显示全屏加载动画
      text: '加载中...', // 可选的加载文本
      });
      // 监听页面加载完成事件
      window.addEventListener('load', () => {
        // 在页面加载完成后关闭加载动画
        loadingInstance.close();
      });
      // 监听路由变化事件，在路由变化时显示加载动画
      router.beforeEach((to, from, next) => {
        loadingInstance && loadingInstance.close(); // 确保先关闭上一个加载动画
        loadingInstance = Loading.service({
          fullscreen: true,
          text: '加载中...',
        });
        next();
      });

      router.afterEach(() => {
        loadingInstance && loadingInstance.close(); // 路由跳转完成后关闭加载动画
      });
    }
  },
  mounted() {
    this.start();
  },
}
</script>

<style lang="less" >
html{
  scroll-behavior: smooth
}
a{
  user-select: none;
  // scroll-behavior: smooth;
}
#app{
  display:flex;
  flex-direction:column;
  position: relative;
  // scroll-behavior: smooth;
  //隐藏拉伸
  // overflow: hidden;
}

//头部
.header{
  height: 100px;
  width: 100%;
  position: fixed;
  //边框
  // border: 5px solid #000;
  z-index: 3;
}
//中间
.main{
  //边框
  // border: 5px solid #008c8c;
  // flex: 1 auto;
  z-index: 2;
}
//尾部
.foot{
  z-index: 1;
  // height: 300px;
  //边框
  // border: 5px solid #d10b0b;
}

</style>
